export type BackendStatus = 'available' | 'busy' | 'offline';
export type FrontendStatus = 'Active' | 'Inactive' | 'On Delivery';

export const mapBackendToFrontendStatus = (status: BackendStatus): FrontendStatus => {
  switch (status) {
    case 'available':
      return 'Active';
    case 'busy':
      return 'On Delivery';
    case 'offline':
      return 'Inactive';
    default:
      return 'Inactive'; // Default to Inactive for any unexpected status
  }
};

export const mapFrontendToBackendStatus = (status: FrontendStatus): BackendStatus => {
  switch (status) {
    case 'Active':
      return 'available';
    case 'On Delivery':
      return 'busy';
    case 'Inactive':
      return 'offline';
    default:
      return 'offline'; // Default to offline for any unexpected status
  }
};

// Helper type to check if a string is a valid FrontendStatus
export const isFrontendStatus = (status: string): status is FrontendStatus => {
  return ['Active', 'Inactive', 'On Delivery'].includes(status);
};

// Helper type to check if a string is a valid BackendStatus
export const isBackendStatus = (status: string): status is BackendStatus => {
  return ['available', 'busy', 'offline'].includes(status);
};
